import AdultDrawingSummary from "@/components/Exercises/DrawingSVGs/AdultDrawingSummary";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/(content)/adults/exercises/(shared)/drawing/summary",
)({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    referrer: search?.referrer as string | undefined,
    referrerGroup: search?.referrerGroup as string | undefined,
  }),
  head: () => ({
    meta: [
      {
        title: "My Drawings - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "drawing.myDrawings",
    navbar: {
      showTitle: true,
    },
  }),
});

function RouteComponent() {
  return (
    <div className="max-w-xl mx-auto px-4 py-6">
      <AdultDrawingSummary />
    </div>
  );
}
